/**
 * NOTE: references the same onboarding-1/2/3 images used on mobile. Make
 * sure these are copied into the web app's asset pipeline at the path below
 * (or update the imports) before this renders correctly.
 */
import React, { useState } from 'react';

import CSSModule from 'react-css-modules';

// import tutorialImage1 from '../../../assets/images/onboarding/onboarding-1.webp';
// import tutorialImage2 from '../../../assets/images/onboarding/onboarding-2.webp';
// import tutorialImage3 from '../../../assets/images/onboarding/onboarding-3.webp';
import styles from './OnboardingSlides.module.scss';

const tutorialImage1 = 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png';
const tutorialImage2 = 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png';
const tutorialImage3 = 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png';

const SLIDES = [tutorialImage1, tutorialImage2, tutorialImage3];

const OnboardingSlides = ({ onComplete }) => {
  const [index, setIndex] = useState(0);
  const isLast = index === SLIDES.length - 1;

  const handleNext = () => {
    if (isLast) {
      onComplete();
    } else {
      setIndex(i => i + 1);
    }
  };

  const handleSkip = () => onComplete();

  return (
    <div styleName="page">
      <div styleName="slide">
        <img src={SLIDES[index]} alt={`Onboarding step ${index + 1}`} styleName="image" />

        <div styleName="dots">
          {SLIDES.map((_, i) => (
            <span key={i} styleName={i === index ? 'dot dot-active' : 'dot'} />
          ))}
        </div>

        <div styleName="button-row">
          <button type="button" styleName="skip-btn" onClick={handleSkip}>
            Skip
          </button>
          <button type="button" styleName="next-btn" onClick={handleNext}>
            {isLast ? 'Complete' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CSSModule(OnboardingSlides, styles, { allowMultiple: true });
